import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import InfoPopper from "../popper/InfoPopper";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { CustomFormHelperText } from "./CustomFormHelperText";
import { FieldError } from "react-hook-form";
import { common, input } from "../../i18n";
import LabelInput from "./LabelInput";

interface Props {
  label: string;
  info?: string;
  value?: string;
  disabled?: boolean;
  required?: boolean;
  error?: FieldError | undefined;
  endIcon?: JSX.Element;
  placeholder?: string;
  handleOnChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  displayOnly?: boolean;
  showLabelInput?: boolean | undefined;
}

const CustomInput = (props: Props) => {
  return (
    <Box>
      {props.showLabelInput === undefined || props.showLabelInput === true ? (
        <LabelInput
          label={props.label}
          info={props.info}
          required={props.required}
        />
      ) : undefined}

      <TextField
        fullWidth
        value={props.value}
        error={props.error ? true : false}
        disabled={props.disabled}
        placeholder={props.placeholder}
        onChange={props.handleOnChange}
        style={{
          margin: "8px 0",
          height: "40px",
          backgroundColor: "var(--white)",
        }}
        InputProps={{
          endAdornment:
            props.endIcon === undefined ? undefined : (
              <InputAdornment position="end">{props.endIcon}</InputAdornment>
            ),
        }}
        label={
          props.showLabelInput === undefined || props.showLabelInput === true
            ? undefined
            : props.label
        }
      />
      <CustomFormHelperText error={props.error} />
    </Box>
  );
};

export default CustomInput;
